import { render } from "./GiftList.vue?vue&type=template&id=f06bd09a&scoped=true"
import script from "./GiftList.vue?vue&type=script&lang=js"
export * from "./GiftList.vue?vue&type=script&lang=js"

import "./GiftList.vue?vue&type=style&index=0&id=f06bd09a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f06bd09a"]])

export default __exports__